<template>
  <div class="content">
    <base-header :choose-index="2" ref="header_content"></base-header>
    <div class="middle_content">
      <swiper :options="swiperOption" class="swiper-container">
        <swiper-slide v-for="(item, index) in content_product_cplb" :key="index">
          <a :href="item.banner_link" target="_blank">
            <div class="middle_content-post" v-bgImg="utils.getQiniuWidthUrl(item.banner_img, 1920, 1, 'webp')"></div>
          </a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="middle_content-classify">
        <div class="middle_content-classify-container">
          <a :href="'/product?id='+item.category_id" class="middle_content-classify-item"
            :style="{'width':1200/website_product_categories.length+'px'}"
            :class="{'middle_content-classify-item-active': item.category_id === website_product_category.category_id}"
            v-for="item in website_product_categories" :key="item.category_id">
            <div class="middle_content-classify-item-pic" v-bgImg="utils.getQiniuWidthUrl(item.category_icon_black, 70, 3, 'png')"
              v-show="item.category_id != website_product_category.category_id"></div>
            <div class="middle_content-classify-item-pic"
              v-bgImg="utils.getQiniuWidthUrl(item.category_icon_orange, 70, 3, 'png')"
              v-show="item.category_id === website_product_category.category_id"></div>
            <div>{{item.category_name}}</div>
          </a>
        </div>
      </div>
      <div class="middle_content-title">{{website_product_category.category_name}}</div>
      <div class="middle_content-list">
        <a :href="'/detail?id='+item.product_id" target="_blank" class="middle_content-list-item" v-for="item in website_products"
          :key="item.product_id">
          <div class="middle_content-list-item-tag"
            v-bgImg="require('@@/assets/img/westa/product/明星产品_'+utils.getCookie('lang')+'.png')"
            v-if="item.product_is_hot === 'true'"></div>
          <div class="middle_content-list-item-pic"
            :class="{'middle_content-list-item-pic-margin': item.product_is_hot === 'false'}"
            v-bgImg="utils.getQiniuWidthUrl(getCover(item.product_imgs), 388, 3, 'png')"></div>
          <div class="middle_content-list-item-title danhang">{{item.product_model}}</div>
          <div class="middle_content-list-item-desc">{{item.product_slogan}}</div>
        </a>
      </div>
      <div class="news_pagination">
        <el-pagination layout="prev, pager, next" background @current-change="getProducts" :current-page.sync="page"
          :page-size.sync="page_count" :total="total"></el-pagination>
      </div>
    </div>
    <base-footer></base-footer>
  </div>
</template>

<script>
import BaseHeader from "@@/components/westa/base-header";
import BaseFooter from "@@/components/westa/base-footer";
export default {
  data() {
    return {
      swiperOption: {
        autoplay: true,
        autoplay: {
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          }
        }
      },
      content_product_cplb: [],
      website_product_categories: [],
      id: "",
      page: 1,
      page_count: 8,
      total: 0,
      website_products: [],
      website_product_category: {}
    };
  },
  components: {
    BaseHeader,
    BaseFooter
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      let id = this.$route.query.id;
      this.id = id;
      this.getProducts();
    }
  },
  created() {
    let id = this.$route.query.id;
    this.id = id;
    console.log(id);
    this.getInfo();
    this.getCategories();
    this.getProducts();
  },
  mounted() { },
  methods: {
    getInfo() {
      let params = {};
      this.req
        .get(
          url_api_web_websiteContent_getWebsiteContent,
          this.qs.stringify(params)
        )
        .then(result => {
          this.content_product_cplb = JSON.parse(
            result.website_content.content_product_cplb
          );
        })
        .catch(error => { });
    },
    getCategories() {
      let params = {};
      this.req
        .get(
          url_api_web_websiteProductCategory_getWebsiteProductCategories,
          this.qs.stringify(params)
        )
        .then(result => {
          this.website_product_categories = result.website_product_categories;
        })
        .catch(error => { });
    },
    getProducts(page) {
      if (page != null) {
        this.page = page;
      }
      let params = {
        page: this.page - 1,
        page_count: this.page_count,
        product_website_product_category_id: this.id
      };
      this.req
        .get(
          url_api_web_websiteProduct_getWebsiteProducts,
          this.qs.stringify(params)
        )
        .then(result => {
          this.website_products = result.website_products;
          this.total = result.total;
          this.website_product_category = result.website_product_category;
        })
        .catch(error => { });
    },
    getCover(str) {
      return str.split(",")[0];
    }
  }
};
</script>


<style lang="less" scoped>
.middle_content {
  padding-top: 64px;
  background: #f9f9f9;
  min-width: 1200px;

  &-post {
    width: 100%;
    height: 925px;
    min-height: 925px;
  }
  &-classify {
    width: 1200px;
    height: 240px;
    margin: 16px auto;
    // display: flex;
    // justify-content: space-around;
    // align-items: center;
    background-color: #fff;
    color: #333;
    margin-bottom: 20px;
    margin-top: 20px;
    z-index: 997;
    position: relative;
    overflow: hidden;
    &-container {
      display: flex;
      overflow-x: scroll;
      overflow-y: hidden;
      // min-width: 0;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
    }
    &-item {
      width: 238px;
      height: 240px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      margin-right: 2px;
      &:last-child {
        margin-right: 0;
      }
      &-pic {
        width: 70px;
        height: 70px;
        margin-bottom: 16px;
      }
      &:hover {
        box-shadow: 0 0 6px 1px #999999;
      }
      &-active {
        color: #181f99;
        // margin-top: -8px;
      }
    }
  }
  &-title {
    font-size: 24px;
    color: #333;
    width: 1200px;
    margin: 40px auto;
    margin-top: 64px;
  }
  &-list {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 88px;
    &-item {
      width: 288px;
      height: 392px;
      margin-right: 16px;
      margin-bottom: 18px;
      background: #fff;
      text-align: center;
      &:nth-child(4n) {
        margin-right: 0;
      }
      &-tag {
        width: 91px;
        height: 32px;
        margin-top: 20px;
        margin-left: 24px;
      }
      &-pic {
        width: 288px;
        height: 210px;
        &-margin {
          margin-top: 52px;
        }
      }

      &-title {
        width: 288px;
        font-size: 20px;
        color: #333;
        margin-top: 24px;
      }
      &-desc {
        font-size: 16px;
        color: #666;
        margin-top: 16px;
      }
    }
  }
}
.news_pagination {
  display: flex;
  justify-content: flex-end;
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}
.danhang {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.duohang {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
